import type { FC, ReactNode } from 'react'
import { createContext, useState, useMemo, useContext } from 'react'

import type { CustomerSetupExportMapping } from '../resources/reports'

type ReportsContext = {
  count: number
  setCount: (v: number) => void
  isReportListLoading: boolean
  setIsReportListLoading: (v: boolean) => void
  customerSpecificReports: CustomerSetupExportMapping[]
  setCustomerSpecificReports: (data: CustomerSetupExportMapping[]) => void
}

const Context = createContext<ReportsContext>({
  isReportListLoading: false,
  setIsReportListLoading: () => {},
  count: 0,
  setCount: () => {},
  customerSpecificReports: [],
  setCustomerSpecificReports: () => {},
})

export const ReportsContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [count, setCount] = useState(0)
  const [isReportListLoading, setIsReportListLoading] = useState(false)
  const [customerSpecificReports, setCustomerSpecificReports] = useState<
    CustomerSetupExportMapping[]
  >([])

  const value: ReportsContext = useMemo(
    () => ({
      count,
      setCount,
      isReportListLoading,
      setIsReportListLoading,
      customerSpecificReports,
      setCustomerSpecificReports,
    }),
    [count, isReportListLoading, customerSpecificReports]
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useReportsContext = () => useContext(Context)
